module.exports = __webpack_public_path__ + "img/stox.ecfc86a7.svg";